import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_zoomRect.css';

export interface WithTypeZoomRectProps {
  type?: 'zoomRect';
}

export const withTypeZoomRect = withBemMod<WithTypeZoomRectProps>(
    'Icon',
    { type: 'zoomRect' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);
